import React, { useState, useRef, useEffect } from "react";
import { lang } from "../../../middleware/lang";
import { formatNumber } from "../../../middleware/common-functions";
import { Link } from "react-router-dom";
import { Button } from "../../common/buttons";

const OrderActions = ({ order, payOut, updateOrder, print, sendPaymentLink, enterSplitBillMode, comandaSelectMode, toggleComandaSelectMode, printComandaSelection }) => {
  const [chargeMenuOpen, setChargeMenuOpen] = useState(false);
  const [comandaMenuOpen, setComandaMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const comandaDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setChargeMenuOpen(false);
      }
      if (comandaDropdownRef.current && !comandaDropdownRef.current.contains(e.target)) {
        setComandaMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
  <div className="col-md-4 mt-4 mt-md-0">
    <div className="p-3">
      <h2 className="my-0 text-center display-4">
        <b className="text-dark invert">${formatNumber(order.total)}</b>
      </h2>
      <h5 className="mb-0 text-center text-muted">
        <small>Total</small>
      </h5>
      <p className="my-1 text-right">
        Subtotal: ${formatNumber(order.subtotal)}
      </p>
      <p className="my-1 text-right">
        I.V.A.: ${formatNumber(order.total - order.subtotal)}
      </p>
      {order.tip > 0 && (
        <p className="my-1 text-right">
          {lang("Propina", "Tip")}: ${formatNumber(order.tip)}
        </p>
      )}
    </div>
    <div className="sticky-top">
      {renderCta(order, payOut, updateOrder, sendPaymentLink, enterSplitBillMode, chargeMenuOpen, setChargeMenuOpen, dropdownRef)}
      <hr />
      <Button
        text={lang("Re-imprimir Ticket Cliente", "Print Customer Ticket")}
        classes="btn btn_xs_lg btn_xs_lg_mob btn-block btn-default text-muted py-4 my-2 mt-4 "
        fun={() => print(order, "client")}
      />
      {comandaSelectMode ? (
        <div className="my-2 mt-4">
          <button
            className="btn btn_xs_lg btn_xs_lg_mob btn-block btn-success py-4"
            onClick={printComandaSelection}
          >
            <i className="fas fa-print mr-2"></i>
            {lang("Imprimir Selección", "Print Selection")}
          </button>
          <button
            className="btn btn_xs_lg btn_xs_lg_mob btn-block btn-default text-muted py-4 my-2"
            onClick={toggleComandaSelectMode}
          >
            {lang("Cancelar", "Cancel")}
          </button>
        </div>
      ) : (
        <div className="my-2 mt-4" style={{ position: "relative" }} ref={comandaDropdownRef}>
          <button
            className="btn btn_xs_lg btn_xs_lg_mob btn-block btn-default text-muted py-4"
            onClick={() => print(order, "restaurant", true)}
          >
            {lang("Re-imprimir Comanda", "Print Ticket")}
          </button>
          <button
            type="button"
            className="btn btn-default text-muted py-4"
            onClick={() => setComandaMenuOpen(!comandaMenuOpen)}
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              bottom: 0,
              borderLeft: "1px solid rgba(0,0,0,0.1)",
              borderRadius: "0 4px 4px 0",
              paddingLeft: 12,
              paddingRight: 12,
            }}
          >
            <i className="fas fa-caret-down"></i>
          </button>
          {comandaMenuOpen && (
            <div className="dropdown-menu dropdown-menu-right show" style={{ top: "100%", right: 0, position: "absolute", zIndex: 10 }}>
              <button className="dropdown-item py-2" onClick={() => { setComandaMenuOpen(false); print(order, "restaurant", true); }}>
                <i className="fas fa-print mr-2"></i>
                {lang("Re-imprimir Comanda", "Reprint Ticket")}
              </button>
              <button className="dropdown-item py-2" onClick={() => { setComandaMenuOpen(false); toggleComandaSelectMode(); }}>
                <i className="fas fa-check-square mr-2"></i>
                {lang("Seleccionar Productos", "Select Products")}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
    <p className="text-danger small display_none mt-5" id="printing_logs">
      {" "}
    </p>
  </div>
  );
};

function renderCta(order, payOut, updateOrder, sendPaymentLink, enterSplitBillMode, chargeMenuOpen, setChargeMenuOpen, dropdownRef) {
  const returnRender = [];
  if (!order.payed && order.status !== "placed" && order.payment_type !== "online") {
    returnRender.push(
      <div key="payedbtn" className="my-2" style={{ position: "relative" }} ref={dropdownRef}>
        <button
          className="btn btn_xs_lg btn_xs_lg_mob btn-block btn-cart py-4"
          onClick={payOut}
          data-testid="order-charge-btn"
        >
          <i className="far fa-money-bill-alt icon_fixed_l"></i> {lang("Cobrar", "Charge")}
        </button>
        <button
          type="button"
          className="btn btn-cart py-4"
          onClick={() => setChargeMenuOpen(!chargeMenuOpen)}
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            borderLeft: "1px solid rgba(0,0,0,0.1)",
            borderRadius: "0 4px 4px 0",
            paddingLeft: 12,
            paddingRight: 12,
          }}
        >
          <i className="fas fa-caret-down"></i>
        </button>
        {chargeMenuOpen && (
          <div className="dropdown-menu dropdown-menu-right show" style={{ top: "100%", right: 0, position: "absolute", zIndex: 10 }}>
            <button className="dropdown-item py-2" onClick={() => { setChargeMenuOpen(false); payOut(); }}>
              <i className="far fa-money-bill-alt mr-2"></i>
              {lang("Cobrar", "Charge")}
            </button>
            <button className="dropdown-item py-2" onClick={() => { setChargeMenuOpen(false); enterSplitBillMode(); }}>
              <i className="fas fa-receipt mr-2"></i>
              {lang("Dividir Cuenta", "Split Bill")}
            </button>
          </div>
        )}
      </div>
    );
    if (sendPaymentLink) {
      returnRender.push(
        <Button
          fun={sendPaymentLink}
          key="paymentlinkbtn"
          text={lang("Enviar Link de Cobro", "Send Payment Link")}
          icon="fas fa-link icon_fixed_l"
          classes="btn btn_xs_lg btn_xs_lg_mob btn-block btn-outline-warning my-2 py-3"
        />
      );
    }
  }

  if (order.status === "placed") {
    returnRender.push(
      <Button
        fun={() => {
          updateOrder("in_progress");
        }}
        key="readybtn"
        text={lang("Aceptar Pedido", "Accept Order")}
        icon="fa fa-check icon_fixed_l"
        classes="btn btn_xs_lg btn_xs_lg_mob btn-block btn-cart my-2 "
        data_testid="order-accept-btn"
      />,
      <Button
        fun={() => {
          updateOrder("cancelled");
        }}
        text={lang("Rechazar Pedido", "Reject ORder")}
        key="cancelbtn"
        icon="fa fa-ban text-danger icon_fixed_l"
        classes="btn btn-block btn-default my-2 mt-5 "
      />
    );
  } else if (order.status !== "fulfilled" && order.status !== "cancelled") {
    returnRender.push(
      <Button
        fun={() => {
          if (order.type !== "online" || order.status === "ready") {
            updateOrder("fulfilled");
          } else {
            updateOrder("ready");
          }
        }}
        key="readybtn"
        text={
          order.type !== "online" || order.status === "ready"
            ? lang("Cerrar Pedido", "Close Order")
            : lang("Marcar Pedido Listo", "Order Ready")
        }
        icon={
          order.type !== "online" || order.status === "ready"
            ? "fa fa-check icon_fixed_l"
            : "fas fa-mobile-alt icon_fixed_l"
        }
        classes={`btn btn_xs_lg btn_xs_lg_mob btn-block my-2 py-4  ${
          order.type !== "online" || order.status === "ready"
            ? "btn-danger"
            : "btn-success"
        }`}
        data_testid="order-close-btn"
      />,
      <Link
        to={`/point_of_sale/${order.id}`}
        className="btn btn-block btn btn_xs_lg btn_xs_lg_mob mt-5 d-md-none btn-info"
        key="editbtn"
      >
        <i className="far fa-edit " aria-hidden="true"></i>{" "}
        {lang("Modificar Pedido", "Edit Order")}
      </Link>,
      <Button
        fun={() => {
          updateOrder("cancelled");
        }}
        priv="131072"
        text={lang("Cancelar Pedido", "Cancel")}
        key="cancelbtn"
        icon="fa fa-ban text-danger icon_fixed_l"
        classes="btn btn-block btn-default my-2 mt-5 "
      />
    );
  } else {
    returnRender.push(
      <Button
        fun={() => {
          updateOrder("in_progress");
        }}
        text={lang("Re activar", "Reactivate")}
        key="reactivatebtn"
        priv="131072"
        icon="fa fa-history icon_fixed_l"
        classes="btn btn_xs_lg btn_xs_lg_mob btn-block btn-default my-2 mt-4 "
      />
    );
  }

  return returnRender;
}

export default OrderActions;
